module.exports = __webpack_public_path__ + "img/methodical.124d5edd.png";